export default __webpack_public_path__ + "static/media/alb.c1cd5d5f.svg";